import Vue from 'vue'
import VueRouter from 'vue-router'
import { homeRoute } from './../modules/home/router'

Vue.use(VueRouter)

const routes = [
  ...homeRoute
]

const router = new VueRouter({
  routes
})

export default router
